var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.97888,
    width: 54.0422,
    height: 54.0422,
    rx: 27.0211,
    fill: "#054834"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4844 39.2148C43.1242 39.2148 43.6533 39.0057 44.0717 38.5873C44.49 38.1689 44.6992 37.6398 44.6992 37C44.6992 36.3602 44.49 35.831 44.0717 35.4127C43.6533 34.9943 43.1242 34.7852 42.4844 34.7852C41.8445 34.7852 41.3154 34.9943 40.8971 35.4127C40.4787 35.831 40.2695 36.3602 40.2695 37C40.2695 37.6398 40.4787 38.1689 40.8971 38.5873C41.3154 39.0057 41.8445 39.2148 42.4844 39.2148ZM38.0547 44.3828C37.2426 44.3828 36.5476 44.0939 35.9698 43.5161C35.391 42.9372 35.1016 42.2418 35.1016 41.4297V32.5703C35.1016 31.7582 35.391 31.0627 35.9698 30.4839C36.5476 29.9061 37.2426 29.6172 38.0547 29.6172H48.3906C49.2027 29.6172 49.8982 29.9061 50.477 30.4839C51.0548 31.0627 51.3437 31.7582 51.3437 32.5703V41.4297C51.3437 42.2418 51.0548 42.9372 50.477 43.5161C49.8982 44.0939 49.2027 44.3828 48.3906 44.3828H38.0547ZM26.2422 50.289C25.4301 50.289 24.7346 50.0001 24.1558 49.4223C23.578 48.8435 23.2891 48.148 23.2891 47.3359V26.6641C23.2891 25.852 23.578 25.1565 24.1558 24.5777C24.7346 23.9999 25.4301 23.7109 26.2422 23.7109H46.9141C47.7262 23.7109 48.4216 23.9999 49.0004 24.5777C49.5783 25.1565 49.8672 25.852 49.8672 26.6641H38.0547C36.3074 26.6641 34.8865 27.2114 33.7918 28.306C32.6962 29.4016 32.1484 30.823 32.1484 32.5703V41.4297C32.1484 43.1769 32.6962 44.5979 33.7918 45.6925C34.8865 46.7881 36.3074 47.3359 38.0547 47.3359H49.8672C49.8672 48.148 49.5783 48.8435 49.0004 49.4223C48.4216 50.0001 47.7262 50.289 46.9141 50.289H26.2422Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.17481,
    y: 5.15369,
    width: 63.6925,
    height: 63.6925,
    rx: 31.8463,
    stroke: "#054834",
    strokeOpacity: 0.18,
    strokeWidth: 9.65039
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.df63a88c35ac978cfc07cb34dbbf83cd.svg";
export { ForwardRef as ReactComponent };